import type { TicketPriority } from '@beacon/core';
import { Badge, type BadgeTone } from '@/components/ui/badge.js';
import { cn } from '@/lib/cn.js';

const toneByPriority: Record<TicketPriority, BadgeTone> = {
  p1: 'red',
  p2: 'yellow',
  p3: 'slate',
};

export function Priority({ p }: { p: TicketPriority }) {
  return (
    <Badge
      tone={toneByPriority[p]}
      className={cn('mono !text-[10.5px] !font-semibold tracking-wider')}
    >
      {p.toUpperCase()}
    </Badge>
  );
}
